import { render, staticRenderFns } from "./EmployerOtherFlatDollarInput.vue?vue&type=template&id=64d2bd35&"
import script from "./EmployerOtherFlatDollarInput.vue?vue&type=script&lang=js&"
export * from "./EmployerOtherFlatDollarInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports